import {
  requestGet,
  requestPost,
  api,
  requestDelete,
  requestPut,
  requestPostFileBlob,
  requestPostFile
} from "../config/Api";

export function getAttachments(params) {
  return requestGet("/attachments/legal/file", { params });
}

export function getLegalFileDocuments(params) {
  return requestGet("/attachments/legal/file/documents", { params });
}

// Tipos de documento habilitados para carga manual (fuentes "Documento cargado en el expediente").
export function getUploadableDocumentTypes() {
  return requestGet("/attachments/legal/file/document/types");
}

export function uploadLegalFileDocuments(formData) {
  return requestPostFile("/attachments/legal/file/document/upload", formData);
}

export function uploadLegalFileDocumentsZip(formData) {
  return requestPostFile("/attachments/legal/file/document/upload/zip", formData);
}

// Corrección manual de los datos leídos del PDF (ej. martillero y matrícula).
export function updateLegalFileDocumentData(id, data) {
  return requestPut(`/attachments/legal/file/document/${id}/data`, { data });
}

// Designación de martillero: asigna el martillero del registro.
export function assignDocumentAuctioneer(id, auctioneerId) {
  return requestPut(`/attachments/legal/file/document/${id}/data`, { auctioneer_id: auctioneerId });
}

export function deleteLegalFileDocument(id) {
  return requestDelete(`/attachments/legal/file/document/${id}`);
}

export function downloadAttachment(id) {
  return api.get(`/attachments/legal/file/download/${id}`, {
    responseType: "blob",
  });
}

export function downloadLegalFileDocument(id) {
  return api.get(`/attachments/legal/file/document/${id}/download`, {
    responseType: "blob",
  });
}

export function getAttachmentLegalFiles(id) {
  return requestGet(`attachments/legal/file/associate/${id}`);
}

export const addAttachmentLegalFilesByCodes = (data) => {
  return requestPost(`/attachments/legal/file/add/legal/file/by-codes`, data);
};

export const removeAttachmentLegalFilesByCodes = (data) => {
  return requestPost(
    `/attachments/legal/file/remove/legal/file/by-codes`,
    data,
  );
};

export function deleteAttachment(id) {
  return requestDelete(`/attachments/legal/file/${id}`);
}

export function uploadSignedZipForGenerated(formData) {
  return requestPostFile(`/attachments/legal/file/upload/signed/multiple/attachments`, formData);
}

export const generatePdfFromExcel = (data) => {
  return requestPostFileBlob(
    "/attachments/legal/file/generated/multiple/attachments",
    data,
  );
};

export const downloadGeneratedZipFromExcel = (formData) => {
  return requestPostFileBlob("/attachments/legal/file/downloaded/multiple/attachments", formData, {
    responseType: "blob",
  });
};

export function uploadAttachmentGenerated(formData) {
  return requestPostFile(`/attachments/legal/file/upload/online/generated/attachments`, formData);
}

export function previewUploadAttachmentGeneratedLawyers(formData) {
  return requestPostFile(`/attachments/legal/file/upload/online/generated/attachments/preview-lawyers`, formData);
}

// Reintenta subir a SAC un escrito fallido (mismo registro).
export function retryEscritoUpload(attachmentId, data) {
  return requestPost(`/attachments/legal/file/${attachmentId}/retry/online`, data);
}

export function uploadAttachmentGeneratedSingle(data) {
  return requestPost(`/attachments/legal/file/upload/online/generated/single`, data);
}

export const revertProveaLegalFileRelation = (payload) =>
  requestPost("/attachments/legal/file/revert/uploaded/provea", payload);

export const revertAllProveaLegalFileRelations = (payload) =>
  requestPost("/attachments/legal/file/revert/all/uploaded/provea", payload);

export function uploadDirectAttachment(legalFileId, formData) {
  return requestPostFile(
    `/attachments/legal/file/upload/direct/${legalFileId}`,
    formData,
  );
}

// export function removeAssigned(data) {
//   return requestPost("/attachments/remove/legal/file", data);
// }

// export function addAssigned(data) {
//   return requestPost("/attachments/add/legal/file", data);
// }
